import store from "@/store/index";
import { config } from "@/utils/configuration/config";
import UserRepoFirebase from "@/repositories/users/UserRepoFirebase";
import User from "@/model/User";
import router from "@/router/index";
import ShipService from "./ShipService";

class UserService {
  private static instance: UserService;
  private usersRepo: any;
  private users: Array<User>;
  private static loggedIn: boolean = false;
  private userUidToBeLoggedWhenCreated = "";

  private constructor() {
    console.log("UserService - constructor");

    if (!config.app.useFirebase) {
      console.log("No hay ningun StaticFirebase para Users.");
    } else {
      this.usersRepo = new UserRepoFirebase();
    }

    this.users = new Array<User>();
  }

  public static getInstance(): UserService {
    console.log("UserService - getInstance");
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }

    return UserService.instance;
  }

  public async getUsers(users: Array<User>) {
    if (this.users.length == 0) {
      await this.usersRepo.getUsers(users, this);
      this.users = users;
    } else {
      this.users.forEach((user) => users.push(user));
    }
  }

  public getUser(userId: string): User | undefined {
    console.log("Se quiere buscar el user con id", userId, "dentro de la lista de Users", this.users);
    return this.users.find((user) => user.id === userId);
  }

  public addNewUserFromRepo(users, id, data) {
    console.log("UserService-addNewUserFromRepo. Añadido user", id, data.name);
    const user = this.getUserFromFirebase(id, data);
    users.push(user);

    // Si el uid coincide con el que se está esperando para hacer el login, se hace
    if (user.uid === this.userUidToBeLoggedWhenCreated) {
      this.selectedUser(user);
    }
  }

  public modifyUserFromRepo(users, id: string, data: any) {
    console.log("UserService-modifyUserFromRepo. Modificado user", id, data);
    const pos = users.map((val) => val.id).indexOf(id);

    const newUserObj = this.getUserFromFirebase(id, data);

    users[pos] = newUserObj;

    if (id === store.getters.currentUser.id) {
      store.commit("SET_CURRENT_USER", newUserObj);
    }
  }

  public removeUserFromRepo(users: Array<User>, id: string) {
    const pos = users.map((val) => val.id).indexOf(id);
    if (pos >= 0) {
      users.splice(pos, 1);
    }
  }

  public selectedUser(user) {
    console.log("Nuevo usuario establecido en la sesión", user);
    if (user == null) {
      store.commit("SET_CURRENT_USER", null);
    } else {
      this.users.forEach((val) => {
        if (val.uid == user.uid) {
          store.commit("SET_CURRENT_USER", val);
        }
      });

      // Una vez establecido un usuario válido, y no antes, vamos a la página principal
      this.routerLogging();
    }
  }

  private getUserFromFirebase(id, data) {
    const user = {
      id: id,
      uid: data.uid,
      firstName: data.firstName,
      lastName: data.lastName,
      sector: data.sector,
      company: data.company,
      charge: data.charge,
      email: data.email,
      administrator: data.administrator,
    };
    console.log("xx222  xxx", user);
    return user;
  }
  //Por ahora no habra name.
  private getUserToFirebase(user) {
    const result = {
      name: user.email ? user.email : undefined,
      administrator: false,
      uid: user.uid ? user.uid : undefined,
      firstName: user.firstName ? user.firstName : undefined,
      lastName: user.lastName ? user.lastName : undefined,
      sector: user.sector ? user.sector : undefined,
      company: user.company ? user.company : undefined,
      charge: user.charge ? user.charge : undefined,
      email: user.email ? user.email : undefined,
    };
    return result;
  }

  public saveUser(user) {
    console.log("UserService-saveUser", user);
    const userToFirebase = this.getUserToFirebase(user);

    return this.usersRepo.saveNewUser(userToFirebase);
  }

  public deleteUser(userId) {
    this.usersRepo.deleteUser(userId);
  }

  // funcion para comprobar si estas loggeado, devuelve un boolean al componente.
  public logged() {
    if (UserService.loggedIn == true) {
      return true;
    } else {
      return false;
    }
  }

  public signIn(signUp: boolean, data: Object) {
    signUp ? this.usersRepo.signin(UserService.instance, data) : this.usersRepo.createUser(UserService.instance, data);
  }
  public emailVerification(email: string) {
    console.log("Verificando email", email, "dentro de la lista de Users", this.users);
    const verf = this.users.find((user) => user.email === email);
    console.log("Verificando email", email, "dentro de la lista de Users", verf);

    // Si se ha encontrado algún usuario (vref != undefined) tenemos un error en el registro
    const errorInVerification = verf;
    return !errorInVerification;
  }
  public loggout() {
    this.usersRepo.loggout(UserService.instance);
    ShipService.getInstance().clearShips();
    router.push({ name: "logging" });
  }

  public routerLogging() {
    if (store.getters.currentUser != null) {
      router.push({ name: "home" });
    }
  }

  public waitUserForSelectWhenCreated(userUid: string) {
    this.userUidToBeLoggedWhenCreated = userUid;
  }
}

export default UserService;
